import Phaser from 'phaser';
import { gameConfig } from './game/config';

// Initialize the game
console.log('🎮 Monsters - Tower Defense Game');
console.log('Starting game...');

const game = new Phaser.Game(gameConfig);

// Expose game instance for debugging (optional)
if (typeof window !== 'undefined') {
  (window as unknown as { game: Phaser.Game }).game = game;
}

// Note: Visibility/focus handling is done in GameplayScene to show the pause menu
// and allow the user to resume. We do NOT pause Phaser scenes here - that would
// stop the update loop and prevent the user from interacting with the pause menu.

console.log('Game initialized successfully!');
